import { IDashboardComponent, IAcquisitionChartConfig } from "../../../types";
import { useFetch } from "../../../../../system/useFetch";
import { DashboardSchemaType, IAcquisitionCell } from "../../../../interruptions/types";
import { ISelectedNode } from "../../../../../types";
import AcqConfigPanel from "../../../../interruptions/dashboard/acqConfigPanel";
import { ReactElement } from "react";

interface IProps {
  component: IDashboardComponent<IAcquisitionChartConfig>;
  updateComponent: (component: IDashboardComponent<IAcquisitionChartConfig>) => void;
  selectedNode: ISelectedNode;
}


const AcquisitionPanel = ({ component, updateComponent, selectedNode }: IProps): ReactElement => {
  const { data: schemas } = useFetch<Record<DashboardSchemaType, any>>(
    {
      module: "dashboard",
      query: "getSchemaConfig",
      payload: {
        nodeID: selectedNode.nodeID,
        nodeType: selectedNode.type
      }
    });

  const updateConfig = (cell: IAcquisitionCell) =>  {
    component.config.acquisitionCell = cell;
    updateComponent({ ...component });
  };

  return (
    <>
      {schemas &&
        <AcqConfigPanel schema={schemas[DashboardSchemaType.Acquisition]} setEditableCell={updateConfig}
          editableCell={component.config.acquisitionCell} disableEvents={true}/>
      }
    </>
  );
};

export default AcquisitionPanel;
